var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.value),function(action,index){return _c('div',{key:action.uniq},[_c('v-action',{attrs:{"action-types":_vm.actionTypes,"value":action},on:{"change":function($event){return _vm.actionChanged(index, $event)}}},[_c('a',{attrs:{"slot":"footer"},on:{"click":function($event){$event.preventDefault();return _vm.removeAction(index)}},slot:"footer"},[_c('icon',{attrs:{"name":"trash-alt"}}),_vm._v(" "+_vm._s(_vm.$t('workflow.delete'))+" ")],1)])],1)}),_c('button',{class:[
      'btn',
      'btn-dark',
      'mt-1',
      'btn-block'
    ],on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v(" + ACTION ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }